import {BbxRequest} from "../../data/Request/BbxRequest";
import {CRMRequestDTO} from "./dto/CRMRequestDTO";
import {Page} from "../../data/Page";
import {CRMView} from "./view/CRMView";
import {requestService} from "../../services/RequestService";
import {ApiRoutes} from "../../routes/ApiRoutes";
import {CRMDetailsView} from "./view/CRMDetailsView";
import {CRMRequestUpdateDTO} from "./dto/CRMRequestUpdateDTO";
import {CrmDueRequestDTO} from "./dto/CrmDueRequestDTO";
import {CrmDueEventView} from "./view/CrmDueEventView";


export const CRMModelAPI = {
    /**
     * Fetches CRM comments based on the provided request object.
     * @param {BbxRequest<CRMRequestDTO>} request - The request object containing filter and pagination info.
     * @returns {Promise<Page<CRMView>>} Promise resolving to a Page of CRMView.
     */
    getCRMComments: async (request: BbxRequest<CRMRequestDTO>): Promise<Page<CRMView>> => {
        const response = await requestService.post(ApiRoutes.REST_API_URL_CRM_COMMENT_READ, request);
        return new Page<CRMView>(CRMView,response.data);
    },
    /**
     * Creates or updates a CRM comment.
     * @param {CRMRequestDTO} request - The DTO containing the CRM comment data.
     * @returns {Promise<boolean>} Promise resolving to true if the operation was successful.
     */
    createOrUpdateCRMComment: async (request: CRMRequestUpdateDTO): Promise<boolean> => {
        const response = await requestService.post(ApiRoutes.REST_API_URL_CRM_COMMENT_CREATE, request);
        return response.data;
    },
    /**
     * Fetches CRM comment details based on the provided request object.
     * @param {CRMRequestDTO} request - The DTO containing the CRM comment details request.
     * @returns {Promise<CRMDetailsView>} Promise resolving to a CRMDetailsView.
     */
    getCrmCommentDetails: async (request: CRMRequestDTO): Promise<CRMDetailsView> => {
        const response = await requestService.post(ApiRoutes.REST_API_URL_CRM_COMMENT_DETAILS, request);
        return response.data;
    },

    /**
     * Checks if there is at least one comment for the given supplier ID.
     * @param supplierId
     * @returns {Promise<boolean>} Promise resolving to true if there is at least one comment, false otherwise.
     */
    hasAtLeastOneComment: async (supplierId: number): Promise<boolean> => {
        if (!ApiRoutes.REST_API_URL_CRM_COMMENT_COUNT) {
            throw new Error("REST_API_URL_CRM_COMMENT_COUNT is not defined");
        }
        const response = await requestService.get(ApiRoutes.REST_API_URL_CRM_COMMENT_COUNT, { supplierId });
        return response.data;
    },

    getDueEvents: async (request: CrmDueRequestDTO): Promise<CrmDueEventView[]> => {
        const response = await requestService.post(ApiRoutes.REST_API_URL_CRM_DUE_EVENTS, request);
        return (response.data as any[]).map((item) => new CrmDueEventView(item));
    },

    /**
     * Count of the operator's open CRM comments due today.
     */
    getTodayReminderCount: async (): Promise<number> => {
        const response = await requestService.get(ApiRoutes.REST_API_URL_CRM_DUE_EVENTS_TODAY_COUNT);
        return response.data as number;
    },

    getSalesDashboardDueEvents: async (vendorId: number | null): Promise<CrmDueEventView[]> => {
        const params = vendorId != null ? { vendorId } : {};
        const response = await requestService.get(ApiRoutes.REST_API_URL_CRM_SALES_DASHBOARD_DUE, params);
        return (response.data as any[]).map((item) => new CrmDueEventView(item));
    }
};
